<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text"
          >
            Registrar Almacén
            <router-link :to="{ name: 'Almacenes' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol sm="9">
                <CInput
                  :value.sync="$v.nombreAlmacen.$model"
                  :isValid="checkIfValid('nombreAlmacen')"
                  label="Nombre del almacén:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido, debe tener al menos 1 caracter y maximo 25 caracteres"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="9">
                <label>Ubicacion:</label>
                <v-select
                  v-model="ubicacion"
                  :options="ubicaciones"
                  class="margin-multi"
                  :loading="isLoadingPage"
                  placeholder="Selecciona una ubicación"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
                <!-- <CSelect
                  :value.sync="$v.ubicacion.$model"
                  :isValid="checkIfValid('ubicacion')"
                  :horizontal="{ input: 'col-sm-12' }"
                  :options="ubicaciones"
                  placeholder="Selecciona una ubicación"
                  invalidFeedback="Campo requerido"
                />-->
                <!-- <v-select
                  :value.sync="$v.ubicacion.$model"
                  :isValid="checkIfValid('ubicacion')"
                  :options="ubicaciones"
                  invalidFeedback="Campo requerido"
                  class="margin-multi"
                  placeholder="Selecciona una ubicación"
                />-->
              </CCol>
              <!-- <CCol v-if="ubicacion" class="d-flex align-items-center pt-4 py-3 pl-0" sm="1">
                <div @click="resetCombo()">
                  <CIcon size="lg" class="text-danger" name="cil-x-circle" />
                </div>
              </CCol>-->
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CAlert
                  fade
                  color="success"
                  class="my-1"
                  :show.sync="currentAlertCounter"
                  >Guardado con éxito.</CAlert
                >
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Almacenes' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>

            <CButton
              @click="addAlmacen()"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <div v-if="isLoading">
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        size="sm"
        title="Almacén"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
        >{{ error }}</CModal
      >
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "NuevoAlmacen",

  components: {
    vSelect
  },

  data() {
    return {
      ubicacion: null,
      nombreAlmacen: "",
      ubicaciones: [],
      isLoading: false,
      isLoadingPage: false,
      currentAlertCounter: 0,
      warningModal: false,
      error: "",
      itemModal: { id: "", name: "" }
    };
  },

  mixins: [validationMixin],
  validations: {
    nombreAlmacen: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(25)
    }
    // ubicacion: {
    //   required
    // }
  },

  computed: {
    isValidAlmacen() {
      return !this.$v.nombreAlmacen.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }

    // isValidUbicacion() {
    //   return !this.$v.ubicacion.$invalid;
    // }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateCombos();
    }
  },

  created() {
    const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
      schema: "ubicaciones",
      filter: {
        where: [
          {
            field: "id",
            value: this.ubicacionRaizValue,
            operator: "="
          },
          {
            field: "payload->suspendido",
            value: false,
            operator: "="
          }
        ]
      },
      order:[{
        field: 'payload->nombre',
        direction: 'asc'
      }]
    });
    const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
      schema: "ubicaciones",
      filter: {
        where: [
          {
            field: "payload->pertenece_id",
            value: 0,
            operator: "="
          },
          {
            field: "payload->suspendido",
            value: false,
            operator: "="
          }
        ]
      },
      order:[{
        field: 'payload->nombre',
        direction: 'asc'
      }]
    });
    this.isLoadingPage = true;
    const cat = [];

    if (this.ubicacionRaizValue) {
      cat.push(ubicacionTemplateRaiz);
    } else {
      cat.push(ubicacionTemplateNoRaiz);
    }

    Promise.all(cat)
      .then(([res]) => {
        this.ubicaciones = res.data.map(ubicacion => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        });
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {
    addAlmacen() {
      this.validateAlmacen();

      if (this.isValidAlmacen) {
        if (!this.ubicacion) {
          this.error = "El campo ubicación es obligatorio";
          this.warningModal = true;
          return;
        }

        this.isLoading = true;
        this.$store
          .dispatch("customActualizarHTTP", {
            schema: "almacenes",
            payload: {
              nombre: this.nombreAlmacen,
              ubicacion_id: this.ubicacion ? this.ubicacion.value : ""
            }
          })
          .then(() => {
            this.currentAlertCounter = 6;
            // console.log(res.data);
            // this.$router.push({ name: "Almacenes" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
          })

          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateAlmacen() {
      this.$v.nombreAlmacen.$touch();
      // this.$v.ubicacion.$touch();
    },
    updateCombos() {
      const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "id",
              value: this.ubicacionRaizValue,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });
      const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->pertenece_id",
              value: 0,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });
      this.isLoadingPage = true;
      const cat = [];

      if (this.ubicacionRaizValue) {
        cat.push(ubicacionTemplateRaiz);
      } else {
        cat.push(ubicacionTemplateNoRaiz);
      }

      Promise.all(cat)
        .then(([res]) => {
          this.ubicaciones = res.data.map(ubicacion => {
            return { value: ubicacion.id, label: ubicacion.payload.nombre };
          });
        })
        .finally(() => (this.isLoadingPage = false));
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
